import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { FilterProps, StringFilter } from './types';

export default function CompCustomFieldStringFilter({ filter, schema, onChange }: FilterProps<StringFilter>) {
  return (
    <ManagedFormGroup
      label={schema.label}
      value={filter}
      onValueChange={onChange}
    />
  );
}
